<div class="row">
    <mat-toolbar>
      <span>Location List</span>
      <span class="fill-remaining-space"></span>
      <button class="btn-dialog-close" mat-stroked-button (click)="onClose()"><mat-icon>clear</mat-icon></button>
    </mat-toolbar>
  </div>
      
  <div class="row mt-2 pl-1">
    <div class="col-md-6">   
       <div class="input-group">
           <span class="input-group-prepend">
               <div class="input-group-text bg-transparent border-right-0"><i class="fa fa-search" ></i></div>
           </span>
           <input  [(ngModel)]="searchKey" (keyup)="applyFilter()" autocomplete="off" class="form-control py-2 border-left-0  border-right-0 border" type="text" placeholder="Search">
           <span class="input-group-append">
             <button class="btn  border-left-0 border" type="button">
                 <i *ngIf="searchKey" (click)="onSearchClear()" class="fa fa-close" ></i>
             </button>
           </span>            
       </div> 
    </div>   
       
       <div class="col-md-6">
        <div class="input-group">
         <input  type="text" [(ngModel)]="location" placeholder="Location" class="form-control">  
         <div class="input-group-append">
           <button type="button" (click)="addLocationBtnClick()" class="btn btn-info btn-sm">
              Add
            </button> 
         </div>
       </div> 
       </div> 

  </div> 
         
  
           <div class="row">
            <div class="col-md-12">
            <mat-table [dataSource]="dataSource" matSort>
             
                  <ng-container matColumnDef="Location">
                    <mat-header-cell *matHeaderCellDef mat-sort-header > Location </mat-header-cell>
                    <mat-cell *matCellDef="let element" > {{element.Location}} </mat-cell>
                  </ng-container>

      
                  <ng-container matColumnDef="CreatedBy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header >CreatedBy</mat-header-cell>
                    <mat-cell *matCellDef="let element" > {{element.CreatedBy}} </mat-cell>
                  </ng-container>    
  
              <ng-container matColumnDef="Action">
                <mat-header-cell *matHeaderCellDef > Action </mat-header-cell>
                <mat-cell *matCellDef="let row" >
                    <button class="btn btn-danger btn-sm ml-1 text-white"  (click)="deleteButtonClick(row.Id)"  data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="far fa-trash-alt"></i> </button>       
                </mat-cell>
              </ng-container>
  
              <ng-container matColumnDef="loading">
                <mat-footer-cell *matFooterCellDef colspan="6" > Loading data... </mat-footer-cell> 
              </ng-container>
  
              <ng-container matColumnDef="noData">
                <mat-footer-cell *matFooterCellDef colspan="6" > No data available in table </mat-footer-cell> 
              </ng-container>
            
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide' : dataSource!=null }"></mat-footer-row>
              <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide' : !(dataSource!=null && dataSource.data.length==0)}"></mat-footer-row>
            </mat-table>
  
            <mat-paginator  [pageSize]="3" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  
            </div>
            
          </div>
  
     
     <script>
     
       $(function () {
       $('[data-toggle="viewTooltip"]').tooltip()
     })
     $(function () {
       $('[data-toggle="deleteTooltip"]').tooltip()
     })
     </script>
  
  
  
  
  

